import { SELECTION_COLUMN_ID } from 'ag-grid-community';
import type { GridApi, SelectionColumnDef } from 'ag-grid-community';
import { Array as A, Option, pipe } from 'effect';

import { GRID_SERVICE_KEYS } from '@/components/AgGrid/helpers';
import { getSelectionColumnDef } from '@/components/AgGrid/helpers/rowSelection';
import { leadingEdge } from '@/components/AgGrid/helpers/gridEdges';

// Together with the master/detail expander column next to it, the checkbox column takes the 80px the
// single checkbox + expander column took before AG Grid 36.
export const SELECTION_COLUMN_WIDTH = 40;

// Locked to the same side as the workspace's other service columns, which RTL mirrors to the right
// (`invertPinnedValue`): AG Grid keeps columns locked to one side apart from those locked to the other.
export const getWorkspaceSelectionColumnDef = (enableRtl: boolean): SelectionColumnDef => ({
  ...getSelectionColumnDef(enableRtl, SELECTION_COLUMN_WIDTH),
  lockPosition: leadingEdge(enableRtl),
  suppressNavigable: true,
  headerComponentParams: {
    suppressHeaderRenderer: true,
  },
});

// AG Grid always creates its checkbox column first. The workspace shows it where the checkbox was before
// AG Grid 36: right after the master/detail expander (`> [ ]`, mirrored in RTL). Call it after anything
// that sets the column order: grid creation and a restored layout.
export const placeSelectionColumn = (api: Pick<GridApi, 'getColumnState' | 'moveColumns'>) =>
  pipe(
    api.getColumnState(),
    A.filter(({ colId }) => colId !== SELECTION_COLUMN_ID),
    A.findFirstIndex(({ colId }) => colId === GRID_SERVICE_KEYS.PREVIEW_CHECKBOX_COLUMN_NAME),
    Option.map((expanderIndex) => api.moveColumns([SELECTION_COLUMN_ID], expanderIndex + 1)),
  );
